import React from 'react'

export const PromptScreen = () => (
  <svg
    width="594"
    height="367"
    viewBox="0 0 594 367"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="594" height="367" rx="5" fill="white" />
    <path d="M0 4C0 1.79086 1.79086 0 4 0H590C592.209 0 594 1.79086 594 4V32H0V4Z" fill="#E4E7ED" />
    <path
      d="M131.999 28.3486L129.387 15.1607C128.996 13.3079 127.168 12 124.949 12H30.6874C28.468 12 26.6402 13.3079 26.2485 15.1607L23.5068 28.3486C23.2457 30.2015 21.2874 31.5094 19.068 31.5094H1V62.1358H593V31.5094H136.568C134.349 31.5094 132.39 30.2015 131.999 28.3486Z"
      fill="white"
    />
    <path
      d="M578.989 43.18H569.473C569.148 43.18 568.932 42.9637 568.932 42.6393C568.932 42.3149 569.148 42.0986 569.473 42.0986H578.989C579.313 42.0986 579.529 42.3149 579.529 42.6393C579.421 42.9637 579.205 43.18 578.989 43.18Z"
      fill="#BDC6CF"
    />
    <path
      d="M578.989 47.181H569.473C569.148 47.181 568.932 46.9647 568.932 46.6403C568.932 46.3159 569.148 46.0996 569.473 46.0996H578.989C579.313 46.0996 579.529 46.3159 579.529 46.6403C579.421 46.9647 579.205 47.181 578.989 47.181Z"
      fill="#BDC6CF"
    />
    <path
      d="M578.989 51.1819H569.473C569.148 51.1819 568.932 50.9657 568.932 50.6413C568.932 50.3169 569.148 50.1006 569.473 50.1006H578.989C579.313 50.1006 579.529 50.3169 579.529 50.6413C579.421 50.9657 579.205 51.1819 578.989 51.1819Z"
      fill="#BDC6CF"
    />
    <path
      d="M29.7371 51.1821C29.6289 51.1821 29.4127 51.1821 29.3045 51.0739C29.0883 50.8577 29.0883 50.5333 29.3045 50.317L32.3323 47.2892L29.3045 44.2614C29.0883 44.0452 29.0883 43.7208 29.3045 43.5045C29.5208 43.2882 29.8452 43.2882 30.0615 43.5045L33.8462 47.2892L30.0615 51.0739C30.0615 51.1821 29.8452 51.1821 29.7371 51.1821Z"
      fill="#BDC6CF"
    />
    <path
      d="M33.1978 47.722H24.6551C24.3307 47.722 24.1144 47.5057 24.1144 47.1813C24.1144 46.8569 24.3307 46.6406 24.6551 46.6406H33.1978C33.5222 46.6406 33.7385 46.8569 33.7385 47.1813C33.7385 47.5057 33.5222 47.722 33.1978 47.722Z"
      fill="#BDC6CF"
    />
    <path
      d="M12.7599 51.1821C12.6517 51.1821 12.4355 51.1821 12.3273 51.0739L8.5426 47.2892L12.3273 43.5045C12.5436 43.2882 12.868 43.2882 13.0843 43.5045C13.3006 43.7208 13.3006 44.0452 13.0843 44.2614L10.0565 47.2892L13.0843 50.317C13.3006 50.5333 13.3006 50.8577 13.0843 51.0739C12.9761 51.1821 12.868 51.1821 12.7599 51.1821Z"
      fill="#BDC6CF"
    />
    <path
      d="M17.8431 47.722H9.30044C8.97604 47.722 8.75977 47.5057 8.75977 47.1813C8.75977 46.8569 8.97604 46.6406 9.30044 46.6406H17.8431C18.1675 46.6406 18.3838 46.8569 18.3838 47.1813C18.3838 47.5057 18.0594 47.722 17.8431 47.722Z"
      fill="#BDC6CF"
    />
    <path
      d="M118.712 23.2324C118.604 23.2324 118.387 23.2324 118.279 23.1243L114.603 19.4477C114.386 19.2314 114.386 18.907 114.603 18.6908C114.819 18.4745 115.143 18.4745 115.36 18.6908L119.036 22.3674C119.253 22.5836 119.253 22.908 119.036 23.1243C119.036 23.2324 118.928 23.2324 118.712 23.2324Z"
      fill="#BDC6CF"
    />
    <path
      d="M115.143 23.2324C115.035 23.2324 114.819 23.2324 114.71 23.1243C114.494 22.908 114.494 22.5836 114.71 22.3674L118.387 18.6908C118.603 18.4745 118.928 18.4745 119.144 18.6908C119.36 18.907 119.36 19.2314 119.144 19.4477L115.467 23.1243C115.359 23.2324 115.251 23.2324 115.143 23.2324Z"
      fill="#BDC6CF"
    />
    <path
      d="M46.8218 51.7228C44.3347 51.7228 42.3883 49.6682 42.3883 47.2892C42.3883 44.8021 44.4429 42.8557 46.8218 42.8557C49.3089 42.8557 51.2554 44.9103 51.2554 47.2892C51.2554 47.6137 51.0391 47.8299 50.7147 47.8299C50.3903 47.8299 50.174 47.6137 50.174 47.2892C50.174 45.451 48.6601 43.9371 46.8218 43.9371C44.9835 43.9371 43.4697 45.451 43.4697 47.2892C43.4697 49.1275 44.9835 50.6414 46.8218 50.6414C47.2544 50.6414 47.5788 50.5333 48.0113 50.4252C48.3357 50.317 48.552 50.4252 48.6601 50.7496C48.7683 51.074 48.6601 51.2903 48.3357 51.3984C47.9032 51.6147 47.3625 51.7228 46.8218 51.7228Z"
      fill="#BDC6CF"
    />
    <path
      d="M52.1212 47.2892L50.9317 49.0193C50.9317 49.1274 50.8236 49.1274 50.7154 49.0193L49.5259 47.2892C49.5259 47.181 49.5259 47.181 49.6341 47.181H52.0131C52.1212 47.0729 52.1212 47.181 52.1212 47.2892Z"
      fill="#BDC6CF"
    />
    <path
      d="M552.848 50.2088L549.82 48.5868L546.792 50.2088L547.333 46.8566L544.954 44.4777L548.306 44.0451L549.82 41.0173L551.334 44.0451L554.686 44.4777L552.307 46.8566L552.848 50.2088ZM549.82 47.6136L551.767 48.5868L551.442 46.4241L552.956 44.9102L550.793 44.5858L549.82 42.6394L548.847 44.5858L546.684 44.9102L548.198 46.4241L547.874 48.5868L549.82 47.6136Z"
      fill="#BDC6CF"
    />
    <path
      d="M141.662 22.8367C141.446 22.8367 141.229 22.6205 141.229 22.4042V16.7812C141.229 16.5649 141.446 16.3486 141.662 16.3486C141.878 16.3486 142.094 16.5649 142.094 16.7812V22.4042C142.094 22.6205 141.878 22.8367 141.662 22.8367Z"
      fill="#BDC6CF"
    />
    <path
      d="M144.474 20.1334H138.851C138.635 20.1334 138.418 19.9171 138.418 19.7009C138.418 19.4846 138.635 19.2683 138.851 19.2683H144.474C144.69 19.2683 144.906 19.4846 144.906 19.7009C145.015 19.9171 144.798 20.1334 144.474 20.1334Z"
      fill="#BDC6CF"
    />
    <path
      d="M547.236 18.4718C549.023 18.4718 550.472 17.023 550.472 15.2359C550.472 13.4488 549.023 12 547.236 12C545.449 12 544 13.4488 544 15.2359C544 17.023 545.449 18.4718 547.236 18.4718Z"
      fill="white"
    />
    <path
      d="M561.992 18.4718C563.779 18.4718 565.228 17.023 565.228 15.2359C565.228 13.4488 563.779 12 561.992 12C560.204 12 558.756 13.4488 558.756 15.2359C558.756 17.023 560.204 18.4718 561.992 18.4718Z"
      fill="white"
    />
    <path
      d="M579.854 14.7182C580.242 17.0481 578.301 18.9896 576.1 18.4719C574.806 18.213 573.77 17.1775 573.511 15.8831C573.123 13.5533 575.065 11.6118 577.265 12.1295C578.559 12.3884 579.595 13.4239 579.854 14.7182Z"
      fill="white"
    />
    <rect x="64.5" y="38.5" width="496" height="15" rx="7" stroke="#E4E7ED" />
  </svg>
)

export const GrantedScreen = () => (
  <svg
    width="594"
    height="367"
    viewBox="0 0 594 367"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="594" height="367" rx="5" fill="white" />
    <path d="M0 4C0 1.79086 1.79086 0 4 0H590C592.209 0 594 1.79086 594 4V32H0V4Z" fill="#E4E7ED" />
    <path
      d="M131.999 28.3486L129.387 15.1607C128.996 13.3079 127.168 12 124.949 12H30.6874C28.468 12 26.6402 13.3079 26.2485 15.1607L23.5068 28.3486C23.2457 30.2015 21.2874 31.5094 19.068 31.5094H1V62.1358H593V31.5094H136.568C134.349 31.5094 132.39 30.2015 131.999 28.3486Z"
      fill="white"
    />
    <path
      d="M578.989 43.18H569.473C569.148 43.18 568.932 42.9638 568.932 42.6394C568.932 42.315 569.148 42.0987 569.473 42.0987H578.989C579.313 42.0987 579.529 42.315 579.529 42.6394C579.421 42.9638 579.205 43.18 578.989 43.18Z"
      fill="#BDC6CF"
    />
    <path
      d="M578.989 47.181H569.473C569.148 47.181 568.932 46.9647 568.932 46.6403C568.932 46.3159 569.148 46.0996 569.473 46.0996H578.989C579.313 46.0996 579.529 46.3159 579.529 46.6403C579.421 46.9647 579.205 47.181 578.989 47.181Z"
      fill="#BDC6CF"
    />
    <path
      d="M578.989 51.1819H569.473C569.148 51.1819 568.932 50.9657 568.932 50.6413C568.932 50.3169 569.148 50.1006 569.473 50.1006H578.989C579.313 50.1006 579.529 50.3169 579.529 50.6413C579.421 50.9657 579.205 51.1819 578.989 51.1819Z"
      fill="#BDC6CF"
    />
    <path
      d="M29.7371 51.182C29.6289 51.182 29.4127 51.182 29.3045 51.0739C29.0883 50.8576 29.0883 50.5332 29.3045 50.3169L32.3323 47.2892L29.3045 44.2614C29.0883 44.0451 29.0883 43.7207 29.3045 43.5044C29.5208 43.2882 29.8452 43.2882 30.0615 43.5044L33.8462 47.2892L30.0615 51.0739C30.0615 51.182 29.8452 51.182 29.7371 51.182Z"
      fill="#BDC6CF"
    />
    <path
      d="M33.1979 47.7219H24.6552C24.3308 47.7219 24.1145 47.5056 24.1145 47.1812C24.1145 46.8568 24.3308 46.6405 24.6552 46.6405H33.1979C33.5223 46.6405 33.7385 46.8568 33.7385 47.1812C33.7385 47.5056 33.5223 47.7219 33.1979 47.7219Z"
      fill="#BDC6CF"
    />
    <path
      d="M12.7599 51.182C12.6517 51.182 12.4355 51.182 12.3273 51.0739L8.5426 47.2892L12.3273 43.5044C12.5436 43.2882 12.868 43.2882 13.0843 43.5044C13.3006 43.7207 13.3006 44.0451 13.0843 44.2614L10.0565 47.2892L13.0843 50.3169C13.3006 50.5332 13.3006 50.8576 13.0843 51.0739C12.9761 51.182 12.868 51.182 12.7599 51.182Z"
      fill="#BDC6CF"
    />
    <path
      d="M17.8431 47.7219H9.30044C8.97604 47.7219 8.75977 47.5056 8.75977 47.1812C8.75977 46.8568 8.97604 46.6406 9.30044 46.6406H17.8431C18.1675 46.6406 18.3838 46.8568 18.3838 47.1812C18.3838 47.5056 18.0594 47.7219 17.8431 47.7219Z"
      fill="#BDC6CF"
    />
    <path
      d="M118.712 23.2324C118.604 23.2324 118.387 23.2324 118.279 23.1242L114.603 19.4476C114.386 19.2314 114.386 18.907 114.603 18.6907C114.819 18.4744 115.143 18.4744 115.36 18.6907L119.036 22.3673C119.253 22.5836 119.253 22.908 119.036 23.1242C119.036 23.2324 118.928 23.2324 118.712 23.2324Z"
      fill="#BDC6CF"
    />
    <path
      d="M115.143 23.2324C115.035 23.2324 114.819 23.2324 114.711 23.1243C114.494 22.908 114.494 22.5836 114.711 22.3674L118.387 18.6908C118.603 18.4745 118.928 18.4745 119.144 18.6908C119.36 18.907 119.36 19.2314 119.144 19.4477L115.467 23.1243C115.359 23.2324 115.251 23.2324 115.143 23.2324Z"
      fill="#BDC6CF"
    />
    <path
      d="M46.8218 51.7227C44.3347 51.7227 42.3883 49.6682 42.3883 47.2892C42.3883 44.8021 44.4429 42.8557 46.8218 42.8557C49.3089 42.8557 51.2554 44.9102 51.2554 47.2892C51.2554 47.6136 51.0391 47.8299 50.7147 47.8299C50.3903 47.8299 50.174 47.6136 50.174 47.2892C50.174 45.4509 48.6601 43.937 46.8218 43.937C44.9835 43.937 43.4697 45.4509 43.4697 47.2892C43.4697 49.1275 44.9835 50.6414 46.8218 50.6414C47.2544 50.6414 47.5788 50.5332 48.0113 50.4251C48.3357 50.317 48.552 50.4251 48.6601 50.7495C48.7683 51.0739 48.6601 51.2902 48.3357 51.3983C47.9032 51.6146 47.3625 51.7227 46.8218 51.7227Z"
      fill="#BDC6CF"
    />
    <path
      d="M52.1211 47.2892L50.9316 49.0193C50.9316 49.1274 50.8235 49.1274 50.7154 49.0193L49.5259 47.2892C49.5259 47.181 49.5259 47.181 49.634 47.181H52.013C52.1211 47.0729 52.1211 47.181 52.1211 47.2892Z"
      fill="#BDC6CF"
    />
    <path
      d="M552.848 50.2089L549.82 48.5868L546.792 50.2089L547.333 46.8567L544.954 44.4777L548.306 44.0452L549.82 41.0174L551.334 44.0452L554.686 44.4777L552.307 46.8567L552.848 50.2089ZM549.82 47.6136L551.767 48.5868L551.442 46.4241L552.956 44.9103L550.793 44.5858L549.82 42.6394L548.847 44.5858L546.684 44.9103L548.198 46.4241L547.874 48.5868L549.82 47.6136Z"
      fill="#BDC6CF"
    />
    <path
      d="M141.662 22.8367C141.446 22.8367 141.229 22.6205 141.229 22.4042V16.7812C141.229 16.5649 141.446 16.3486 141.662 16.3486C141.878 16.3486 142.094 16.5649 142.094 16.7812V22.4042C142.094 22.6205 141.878 22.8367 141.662 22.8367Z"
      fill="#BDC6CF"
    />
    <path
      d="M144.474 20.1333H138.851C138.635 20.1333 138.418 19.9171 138.418 19.7008C138.418 19.4845 138.635 19.2682 138.851 19.2682H144.474C144.69 19.2682 144.906 19.4845 144.906 19.7008C145.015 19.9171 144.798 20.1333 144.474 20.1333Z"
      fill="#BDC6CF"
    />
    <path
      d="M547.236 18.4718C549.023 18.4718 550.472 17.023 550.472 15.2359C550.472 13.4488 549.023 12 547.236 12C545.449 12 544 13.4488 544 15.2359C544 17.023 545.449 18.4718 547.236 18.4718Z"
      fill="white"
    />
    <path
      d="M561.992 18.4718C563.779 18.4718 565.227 17.023 565.227 15.2359C565.227 13.4488 563.779 12 561.992 12C560.204 12 558.756 13.4488 558.756 15.2359C558.756 17.023 560.204 18.4718 561.992 18.4718Z"
      fill="white"
    />
    <path
      d="M579.854 14.7182C580.242 17.0481 578.301 18.9896 576.1 18.4719C574.806 18.213 573.77 17.1775 573.511 15.8831C573.123 13.5533 575.065 11.6118 577.265 12.1295C578.559 12.3884 579.595 13.4239 579.854 14.7182Z"
      fill="white"
    />
    <rect x="64.5" y="38.5" width="496" height="15" rx="7" stroke="#E4E7ED" />
    <g filter="url(#filter0_d_10_7351)">
      <rect x="393" y="145" width="153.816" height="174" rx="5" fill="white" />
    </g>
    <path
      d="M393 287.177H546.982V314C546.982 316.762 544.744 319 541.982 319H398C395.239 319 393 316.762 393 314V287.177Z"
      fill="#F8F9FB"
    />
    <line x1="546.982" y1="287.164" x2="393" y2="287.164" stroke="#E4E7ED" />
    <path
      d="M417.36 298.64C417.36 296.431 419.151 294.64 421.36 294.64H462.08C464.289 294.64 466.08 296.431 466.08 298.64V307.344C466.08 309.553 464.289 311.344 462.08 311.344H421.36C419.151 311.344 417.36 309.553 417.36 307.344V298.64Z"
      fill="#BDC3CF"
    />
    <path
      d="M478.887 298.64C478.887 296.431 480.678 294.64 482.887 294.64H523.607C525.816 294.64 527.607 296.431 527.607 298.64V307.344C527.607 309.553 525.816 311.344 523.607 311.344H482.887C480.678 311.344 478.887 309.553 478.887 307.344V298.64Z"
      fill="#1B72F2"
    />
    <rect x="409.938" y="246.628" width="129.345" height="18.4779" fill="white" />
    <line x1="409.938" y1="208.146" x2="539.283" y2="208.146" stroke="#E4E7ED" />
    <line x1="409.938" y1="227.137" x2="539.283" y2="227.137" stroke="#E4E7ED" />
    <line x1="409.938" y1="246.128" x2="539.283" y2="246.128" stroke="#E4E7ED" />
    <line x1="409.938" y1="265.12" x2="539.283" y2="265.12" stroke="#E4E7ED" />
    <line x1="409.938" y1="189.155" x2="539.283" y2="189.155" stroke="#E4E7ED" />
    <circle cx="403.266" cy="198.894" r="2.56637" fill="#1B72F2" />
    <circle cx="403.266" cy="217.885" r="2.56637" fill="#1B72F2" />
    <circle cx="403.266" cy="236.876" r="2.56637" fill="#1B72F2" />
    <circle cx="403.266" cy="255.867" r="2.56637" fill="#29BC7E" />
    <line x1="393" y1="167.597" x2="546.982" y2="167.597" stroke="#E4E7ED" />
    <path
      d="M507.2 154.097L506.703 154.594C506.654 154.641 506.589 154.667 506.521 154.667C506.453 154.666 506.388 154.639 506.34 154.591C506.292 154.543 506.265 154.478 506.264 154.41C506.264 154.342 506.29 154.277 506.337 154.228L507.277 153.288C507.301 153.264 507.329 153.245 507.361 153.232C507.392 153.219 507.426 153.212 507.46 153.212C507.494 153.212 507.528 153.219 507.559 153.232C507.591 153.245 507.619 153.264 507.643 153.288L508.584 154.229C508.609 154.253 508.629 154.282 508.642 154.313C508.656 154.345 508.663 154.379 508.663 154.413C508.664 154.448 508.657 154.482 508.644 154.514C508.631 154.545 508.612 154.574 508.587 154.599C508.563 154.623 508.534 154.642 508.502 154.655C508.47 154.668 508.436 154.675 508.402 154.674C508.368 154.674 508.334 154.667 508.302 154.653C508.27 154.64 508.241 154.619 508.217 154.595L507.719 154.097V156.033H509.655L509.157 155.534C509.132 155.51 509.112 155.482 509.098 155.45C509.085 155.419 509.078 155.385 509.077 155.35C509.077 155.316 509.084 155.282 509.097 155.25C509.11 155.218 509.129 155.189 509.153 155.165C509.178 155.14 509.207 155.121 509.238 155.108C509.27 155.095 509.304 155.089 509.339 155.089C509.373 155.089 509.407 155.096 509.439 155.11C509.47 155.123 509.5 155.144 509.523 155.169L510.464 156.109C510.488 156.133 510.507 156.161 510.52 156.193C510.533 156.224 510.54 156.258 510.54 156.292C510.54 156.326 510.533 156.36 510.52 156.391C510.507 156.423 510.488 156.452 510.464 156.476L509.523 157.416C509.499 157.441 509.47 157.461 509.439 157.474C509.407 157.488 509.373 157.495 509.339 157.495C509.304 157.496 509.27 157.489 509.238 157.476C509.207 157.463 509.178 157.444 509.153 157.42C509.129 157.395 509.11 157.366 509.097 157.335C509.084 157.303 509.077 157.269 509.077 157.234C509.078 157.2 509.085 157.166 509.098 157.134C509.112 157.103 509.132 157.073 509.157 157.05L509.655 156.551H507.719V158.487L508.216 157.99C508.265 157.943 508.33 157.917 508.398 157.917C508.466 157.918 508.531 157.945 508.579 157.993C508.627 158.041 508.654 158.106 508.655 158.174C508.656 158.242 508.629 158.307 508.582 158.356L507.643 159.296C507.619 159.32 507.59 159.339 507.559 159.352C507.527 159.365 507.493 159.372 507.459 159.372C507.425 159.372 507.392 159.365 507.36 159.352C507.329 159.339 507.3 159.32 507.276 159.296L506.336 158.356C506.289 158.307 506.263 158.242 506.264 158.174C506.264 158.106 506.292 158.041 506.34 157.993C506.388 157.945 506.453 157.918 506.52 157.917C506.588 157.917 506.654 157.943 506.703 157.99L507.2 158.487V156.551H505.264L505.763 157.05C505.788 157.074 505.808 157.102 505.821 157.134C505.835 157.166 505.842 157.2 505.842 157.234C505.842 157.268 505.836 157.302 505.823 157.334C505.81 157.366 505.791 157.395 505.766 157.419C505.742 157.444 505.713 157.463 505.681 157.476C505.649 157.489 505.615 157.495 505.581 157.495C505.546 157.495 505.512 157.488 505.481 157.474C505.449 157.461 505.42 157.44 505.396 157.415L504.456 156.475C504.432 156.451 504.413 156.423 504.4 156.391C504.387 156.36 504.38 156.326 504.381 156.292C504.381 156.258 504.388 156.224 504.401 156.193C504.414 156.161 504.433 156.132 504.458 156.108L505.398 155.168L505.4 155.167L505.4 155.166C505.424 155.14 505.452 155.118 505.484 155.103C505.516 155.088 505.551 155.08 505.587 155.079C505.622 155.078 505.657 155.084 505.69 155.097C505.723 155.11 505.753 155.13 505.778 155.155C505.802 155.18 505.822 155.21 505.835 155.243C505.848 155.276 505.854 155.311 505.853 155.347C505.852 155.382 505.843 155.417 505.828 155.449C505.813 155.481 505.791 155.509 505.765 155.532L505.264 156.033H507.2V154.097Z"
      fill="#777D87"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M531.159 157.92C531.049 158.031 531.041 158.201 531.141 158.301C531.241 158.402 531.412 158.393 531.522 158.283L533.137 156.668L534.752 158.283C534.862 158.393 535.033 158.402 535.133 158.301C535.234 158.201 535.225 158.031 535.115 157.92L533.5 156.305L535.115 154.69C535.225 154.58 535.234 154.409 535.133 154.309C535.033 154.209 534.862 154.217 534.752 154.327L533.137 155.942L531.522 154.327C531.412 154.217 531.241 154.209 531.141 154.309C531.041 154.409 531.049 154.58 531.159 154.69L532.774 156.305L531.159 157.92Z"
      fill="#777D87"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M518 158.75C518 158.612 518.112 158.5 518.25 158.5H522.75C522.888 158.5 523 158.612 523 158.75C523 158.888 522.888 159 522.75 159H518.25C518.112 159 518 158.888 518 158.75Z"
      fill="#777D87"
    />
    <circle cx="408.912" cy="156.292" r="8.21239" fill="#1B72F2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M406.064 153.088C406.064 152.307 406.697 151.673 407.479 151.673H411.569C412.351 151.673 412.984 152.307 412.984 153.088C412.984 153.87 412.351 154.504 411.569 154.504H407.479C406.697 154.504 406.064 153.87 406.064 153.088ZM405.435 156.549C405.435 155.767 406.068 155.133 406.85 155.133H409.367C410.149 155.133 410.783 155.767 410.783 156.549C410.783 157.331 410.149 157.964 409.367 157.964H406.85C406.068 157.964 405.435 157.331 405.435 156.549ZM406.221 158.594C405.439 158.594 404.805 159.227 404.805 160.009C404.805 160.791 405.439 161.425 406.221 161.425C407.003 161.425 407.637 160.791 407.637 160.009C407.637 159.227 407.003 158.594 406.221 158.594Z"
      fill="white"
    />
    <path
      d="M415.584 153.213C417.002 153.213 418.151 152.064 418.151 150.646C418.151 149.229 417.002 148.08 415.584 148.08C414.167 148.08 413.018 149.229 413.018 150.646C413.018 152.064 414.167 153.213 415.584 153.213Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M417.124 150.646C417.124 151.497 416.435 152.186 415.584 152.186C414.734 152.186 414.044 151.497 414.044 150.646C414.044 149.796 414.734 149.106 415.584 149.106C416.435 149.106 417.124 149.796 417.124 150.646ZM415.584 152.699C416.718 152.699 417.637 151.78 417.637 150.646C417.637 149.512 416.718 148.593 415.584 148.593C414.45 148.593 413.531 149.512 413.531 150.646C413.531 151.78 414.45 152.699 415.584 152.699ZM416.611 150.646C416.611 151.213 416.151 151.673 415.584 151.673C415.017 151.673 414.558 151.213 414.558 150.646C414.558 150.079 415.017 149.62 415.584 149.62C416.151 149.62 416.611 150.079 416.611 150.646Z"
      fill="#FD3730"
    />
    <rect x="400.656" y="177.016" width="114.84" height="4.176" rx="1" fill="#E4E7ED" />
    <rect x="409.704" y="198.592" width="91.872" height="2.088" rx="1" fill="#E4E7ED" />
    <rect x="409.704" y="216.688" width="91.872" height="2.088" rx="1" fill="#E4E7ED" />
    <rect x="409.704" y="234.784" width="91.872" height="2.088" rx="1" fill="#E4E7ED" />
    <rect x="409.704" y="253.576" width="91.872" height="2.088" rx="1" fill="#E4E7ED" />
    <defs>
      <filter
        id="filter0_d_10_7351"
        x="374"
        y="134"
        width="191.816"
        height="212"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="9.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.705816 0 0 0 0 0.710822 0 0 0 0 0.720833 0 0 0 0.33 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10_7351" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10_7351" result="shape" />
      </filter>
    </defs>
  </svg>
)

export const DeniedScreen = () => (
  <svg
    width="594"
    height="367"
    viewBox="0 0 594 367"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="594" height="367" rx="5" fill="white" />
    <path d="M0 4C0 1.79086 1.79086 0 4 0H590C592.209 0 594 1.79086 594 4V32H0V4Z" fill="#E4E7ED" />
    <path
      d="M131.999 28.3486L129.387 15.1607C128.996 13.3079 127.168 12 124.949 12H30.6874C28.468 12 26.6402 13.3079 26.2485 15.1607L23.5068 28.3486C23.2457 30.2015 21.2874 31.5094 19.068 31.5094H1V62.1358H593V31.5094H136.568C134.349 31.5094 132.39 30.2015 131.999 28.3486Z"
      fill="white"
    />
    <path
      d="M578.989 43.18H569.473C569.148 43.18 568.932 42.9637 568.932 42.6393C568.932 42.3149 569.148 42.0986 569.473 42.0986H578.989C579.313 42.0986 579.529 42.3149 579.529 42.6393C579.421 42.9637 579.205 43.18 578.989 43.18Z"
      fill="#BDC6CF"
    />
    <path
      d="M578.989 47.181H569.473C569.148 47.181 568.932 46.9647 568.932 46.6403C568.932 46.3159 569.148 46.0996 569.473 46.0996H578.989C579.313 46.0996 579.529 46.3159 579.529 46.6403C579.421 46.9647 579.205 47.181 578.989 47.181Z"
      fill="#BDC6CF"
    />
    <path
      d="M578.989 51.1819H569.473C569.148 51.1819 568.932 50.9657 568.932 50.6413C568.932 50.3169 569.148 50.1006 569.473 50.1006H578.989C579.313 50.1006 579.529 50.3169 579.529 50.6413C579.421 50.9657 579.205 51.1819 578.989 51.1819Z"
      fill="#BDC6CF"
    />
    <path
      d="M29.7368 51.1821C29.6287 51.1821 29.4124 51.1821 29.3043 51.0739C29.088 50.8577 29.088 50.5333 29.3043 50.317L32.3321 47.2892L29.3043 44.2614C29.088 44.0452 29.088 43.7208 29.3043 43.5045C29.5206 43.2882 29.845 43.2882 30.0612 43.5045L33.846 47.2892L30.0612 51.0739C30.0612 51.1821 29.845 51.1821 29.7368 51.1821Z"
      fill="#BDC6CF"
    />
    <path
      d="M33.1976 47.722H24.6549C24.3305 47.722 24.1143 47.5057 24.1143 47.1813C24.1143 46.8569 24.3305 46.6406 24.6549 46.6406H33.1976C33.522 46.6406 33.7383 46.8569 33.7383 47.1813C33.7383 47.5057 33.522 47.722 33.1976 47.722Z"
      fill="#BDC6CF"
    />
    <path
      d="M12.7597 51.1821C12.6516 51.1821 12.4353 51.1821 12.3272 51.0739L8.54248 47.2892L12.3272 43.5045C12.5435 43.2882 12.8679 43.2882 13.0842 43.5045C13.3004 43.7208 13.3004 44.0452 13.0842 44.2614L10.0564 47.2892L13.0842 50.317C13.3004 50.5333 13.3004 50.8577 13.0842 51.0739C12.976 51.1821 12.8679 51.1821 12.7597 51.1821Z"
      fill="#BDC6CF"
    />
    <path
      d="M17.8429 47.722H9.3002C8.97579 47.722 8.75952 47.5057 8.75952 47.1813C8.75952 46.8569 8.97579 46.6406 9.3002 46.6406H17.8429C18.1673 46.6406 18.3835 46.8569 18.3835 47.1813C18.3835 47.5057 18.0591 47.722 17.8429 47.722Z"
      fill="#BDC6CF"
    />
    <path
      d="M118.712 23.2324C118.604 23.2324 118.387 23.2324 118.279 23.1243L114.603 19.4477C114.386 19.2314 114.386 18.907 114.603 18.6908C114.819 18.4745 115.143 18.4745 115.36 18.6908L119.036 22.3674C119.252 22.5836 119.252 22.908 119.036 23.1243C119.036 23.2324 118.928 23.2324 118.712 23.2324Z"
      fill="#BDC6CF"
    />
    <path
      d="M115.143 23.2324C115.035 23.2324 114.818 23.2324 114.71 23.1243C114.494 22.908 114.494 22.5836 114.71 22.3674L118.387 18.6908C118.603 18.4745 118.928 18.4745 119.144 18.6908C119.36 18.907 119.36 19.2314 119.144 19.4477L115.467 23.1243C115.359 23.2324 115.251 23.2324 115.143 23.2324Z"
      fill="#BDC6CF"
    />
    <path
      d="M46.8217 51.7228C44.3346 51.7228 42.3882 49.6682 42.3882 47.2892C42.3882 44.8021 44.4427 42.8557 46.8217 42.8557C49.3088 42.8557 51.2553 44.9103 51.2553 47.2892C51.2553 47.6137 51.039 47.8299 50.7146 47.8299C50.3902 47.8299 50.1739 47.6137 50.1739 47.2892C50.1739 45.451 48.66 43.9371 46.8217 43.9371C44.9834 43.9371 43.4695 45.451 43.4695 47.2892C43.4695 49.1275 44.9834 50.6414 46.8217 50.6414C47.2543 50.6414 47.5787 50.5333 48.0112 50.4252C48.3356 50.317 48.5519 50.4252 48.66 50.7496C48.7682 51.074 48.66 51.2903 48.3356 51.3984C47.9031 51.6147 47.3624 51.7228 46.8217 51.7228Z"
      fill="#BDC6CF"
    />
    <path
      d="M52.1211 47.2892L50.9316 49.0193C50.9316 49.1274 50.8235 49.1274 50.7154 49.0193L49.5259 47.2892C49.5259 47.181 49.5259 47.181 49.634 47.181H52.013C52.1211 47.0729 52.1211 47.181 52.1211 47.2892Z"
      fill="#BDC6CF"
    />
    <path
      d="M552.848 50.2088L549.82 48.5868L546.792 50.2088L547.333 46.8566L544.954 44.4777L548.306 44.0451L549.82 41.0173L551.334 44.0451L554.686 44.4777L552.307 46.8566L552.848 50.2088ZM549.82 47.6136L551.767 48.5868L551.442 46.4241L552.956 44.9102L550.793 44.5858L549.82 42.6394L548.847 44.5858L546.684 44.9102L548.198 46.4241L547.874 48.5868L549.82 47.6136Z"
      fill="#BDC6CF"
    />
    <path
      d="M141.662 22.8367C141.446 22.8367 141.229 22.6205 141.229 22.4042V16.7812C141.229 16.5649 141.446 16.3486 141.662 16.3486C141.878 16.3486 142.095 16.5649 142.095 16.7812V22.4042C142.095 22.6205 141.878 22.8367 141.662 22.8367Z"
      fill="#BDC6CF"
    />
    <path
      d="M144.474 20.1334H138.851C138.635 20.1334 138.418 19.9171 138.418 19.7009C138.418 19.4846 138.635 19.2683 138.851 19.2683H144.474C144.69 19.2683 144.907 19.4846 144.907 19.7009C145.015 19.9171 144.798 20.1334 144.474 20.1334Z"
      fill="#BDC6CF"
    />
    <path
      d="M547.236 18.4718C549.023 18.4718 550.472 17.023 550.472 15.2359C550.472 13.4488 549.023 12 547.236 12C545.449 12 544 13.4488 544 15.2359C544 17.023 545.449 18.4718 547.236 18.4718Z"
      fill="white"
    />
    <path
      d="M561.992 18.4718C563.779 18.4718 565.227 17.023 565.227 15.2359C565.227 13.4488 563.779 12 561.992 12C560.204 12 558.756 13.4488 558.756 15.2359C558.756 17.023 560.204 18.4718 561.992 18.4718Z"
      fill="white"
    />
    <path
      d="M579.854 14.7182C580.242 17.0481 578.301 18.9896 576.1 18.4719C574.806 18.213 573.77 17.1775 573.511 15.8831C573.123 13.5533 575.065 11.6118 577.265 12.1295C578.559 12.3884 579.595 13.4239 579.854 14.7182Z"
      fill="white"
    />
    <rect x="64.5" y="38.5" width="496" height="15" rx="7" stroke="#E4E7ED" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.0476 44.5303H74.7779V43.9224C74.7779 43.2511 74.1667 42.7069 73.4127 42.7069C72.6588 42.7069 72.0476 43.2511 72.0476 43.9224V44.5303ZM71.365 44.5303C70.6111 44.5304 70 45.0745 70 45.7458V48.7845C70 49.4558 70.6112 50 71.3652 50H75.4607C76.2147 50 76.8259 49.4558 76.8259 48.7845V45.7458C76.8259 45.0745 76.2147 44.5303 75.4607 44.5303H75.4605V43.9224C75.4605 42.9154 74.5437 42.0991 73.4127 42.0991C72.2818 42.0991 71.365 42.9154 71.365 43.9224V44.5303Z"
      fill="#BDC6CF"
    />
  </svg>
)
